import React from 'react';
import { Sun, Droplets, Moon, Activity } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function Solution() {
  const steps = [{
    icon: Sun,
    title: 'Luz Matinal',
    desc: 'Reinicia tu ritmo circadiano dentro de los primeros 30 minutos al despertar para optimizar el cortisol.'
  }, {
    icon: Droplets,
    title: 'Balance Mineral',
    desc: 'Restaura la energía celular agotada con protocolos de hidratación dirigidos.'
  }, {
    icon: Activity,
    title: 'Glucosa Estable',
    desc: 'Secuencia simple de alimentos para evitar los picos que causan el caos hormonal.'
  }, {
    icon: Moon,
    title: 'Descanso Profundo',
    desc: 'Rutinas nocturnas diseñadas para reducir las hormonas del estrés y sanar a profundidad.'
  }];
  return <section id="method" className="py-16 md:py-24 bg-sage/30" data-id="element-190">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-191">
        <div className="max-w-3xl mx-auto text-center mb-12 md:mb-20" data-id="element-192">
          <FadeIn data-id="element-193">
            <span className="uppercase tracking-[0.2em] text-xs text-ink-light mb-4 block" data-id="element-194">
              El Método
            </span>
            <h2 className="font-serif text-3xl md:text-5xl text-ink mb-5 md:mb-6" data-id="element-195">
              El Método del <em className="italic" data-id="element-196">1%</em>
            </h2>
            <p className="text-base md:text-lg text-ink-light font-light leading-relaxed" data-id="element-197">
              Sanar no requiere dietas extremas ni entrenamientos agotadores.
              Requiere consistencia. Al hacer pequeños cambios estratégicos del
              1% en tu rutina diaria, generas resultados que se acumulan y
              transforman tu salud hormonal desde adentro hacia afuera.
            </p>
          </FadeIn>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8" data-id="element-198">
          {steps.map((step, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-199">
              <div className="flex flex-col items-center text-center group" data-id="element-200">
                <span className="font-serif text-5xl md:text-6xl italic text-sand-dark/30 mb-4 block leading-none transition-colors duration-500 group-hover:text-sand-dark/60" data-id="element-201">
                  0{index + 1}
                </span>
                <div className="mb-4 text-ink" data-id="element-202">
                  <step.icon strokeWidth={1} className="w-10 h-10 md:w-11 md:h-11" data-id="element-203" />
                </div>
                <h3 className="font-serif text-xl md:text-2xl mb-3 text-ink" data-id="element-204">
                  {step.title}
                </h3>
                <p className="text-sm md:text-[15px] text-ink-light font-light leading-relaxed max-w-xs" data-id="element-205">
                  {step.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}